import React, { FC } from 'react';
import {
  formatCurrency,
  formatPercentage,
  wholeNumberPercentage
} from '../../utils/numberFormatter';
import { ASSET_NAME } from '../../utils/constants';
import './AssetSummaryTable.scss';
import TableHeading from '../styled/TableHeading';

type Props = {
  className?: string;
  assetCategory: AssetCategory;
  invGuidelines: InvGuidelinesDetail;
};

const AssetSummaryTable: FC<Props> = ({
  className,
  assetCategory: { assetName, assetTotal },
  invGuidelines
}) => (
  <div className={className}>
    <TableHeading tableType="Current Holdings" tableTitle={assetName} />
    <div className="highlighted-data-row">
      <div className="value-title">Market Value</div>
      <div className="value-display">
        {formatCurrency(assetTotal.marketValue)}
      </div>
    </div>
    <div className="data-row">
      <span className="data-field data-title">Cost</span>
      <span className="data-field data-value">
        {formatCurrency(assetTotal.cost)}
      </span>
    </div>
    <div className="data-row">
      <span className="data-field data-title">Estimated Annual Income</span>
      <span className="data-field data-value">
        {formatCurrency(assetTotal.annualIncome)}
      </span>
    </div>
    <div className="data-row">
      <span className="data-field data-title">Estimated Yield at Market</span>
      <span className="data-field data-value">
        {formatPercentage(assetTotal.marketYieldPercent)}
      </span>
    </div>
    <div className="data-row">
      <span className="data-field data-title portfolio-title">
        Percent of Portfolio
      </span>
      <span className="data-field data-value portfolio-value">
        {formatPercentage(assetTotal.percentOfPortfolio)}
      </span>
    </div>
    <div className="data-row">
      <span className="data-field data-title">Investment Guidelines</span>
      {assetName && assetName === ASSET_NAME.RESERVES && invGuidelines && (
        <span className="data-field data-value">
          {wholeNumberPercentage(invGuidelines.reservesMin)} -{' '}
          {wholeNumberPercentage(invGuidelines.reservesMaximum)}
        </span>
      )}
      {assetName && assetName === ASSET_NAME.FIXED_INCOME && invGuidelines && (
        <span className="data-field data-value">
          {wholeNumberPercentage(invGuidelines.fixedIncomeMin)} -{' '}
          {wholeNumberPercentage(invGuidelines.fixedIncomeMaximum)}
        </span>
      )}
      {assetName && assetName === ASSET_NAME.EQUITIES && invGuidelines && (
        <span className="data-field data-value">
          {wholeNumberPercentage(invGuidelines.equitiesMin)} -{' '}
          {wholeNumberPercentage(invGuidelines.equitiesMaximum)}
        </span>
      )}
    </div>
  </div>
);

export default AssetSummaryTable;
